// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1F-N5","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__1J-Gd"};